define('uikit/helper/browser',['require','exports','module','jquery'],function(require, exports, module){
  var $ = require('jquery');

  var Browser = {

    // If IE browser, return version number
    isIE: function() {
      var userAgent = navigator.userAgent.toLowerCase();

      // Check for IE 10 or below
      if (userAgent.indexOf('msie') != -1) {
        return parseInt(userAgent.split('msie')[1]);

      // Check for IE 11 or above
      } else if (userAgent.indexOf('trident') != -1) {
        return parseInt(userAgent.split('rv:')[1]);
      }

      return false;
    }

  };

  module.exports = Browser;

});
